import { motion, useScroll, useTransform } from 'framer-motion'
import { useRef } from 'react'

const Hero = () => {

  const ref = useRef(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"]
  })
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "50%"])

  return (
    <section ref={ref} id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <motion.div 
        style={{ y }}
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
      >
        <div 
          className="absolute inset-0 h-[120%] bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('/HeroBG_img.png')`,
          }}
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-ds-navy/10 via-ds-navy/15 to-ds-navy/15" />
      </motion.div>

      {/* Content */}
      <div className="relative z-10 max-w-full px-4 sm:px-6 my-auto lg:px-12 pt-20 sm:pt-24 lg:pt-32 pb-12 sm:pb-16">
        <div className="max-w-4xl">
          {/* Tagline */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="font-body text-xs sm:text-sm lg:text-base text-white/85 mb-3 sm:mb-4 lg:mb-6"
          >
            Daily Stride LLC imagines, develops, and manages original digital products.
          </motion.p>

          {/* Main Headline */}
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-light leading-tight text-white"
          >
            We Turn Bold Ideas Into
            <br />
            Functional Mobile And Web
            <br />
            Applications, Built In-House
            <br />
            And Maintained With Care.
          </motion.h1>

        </div>
      </div>
    </section>
  )
}

export default Hero
